import React from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import { StoreType } from "client/store"

interface DefaultProps {
    marginLeft?: boolean
}

export const DefaultSpan = styled.span<DefaultProps>`
    margin-left: ${(props) => (props.marginLeft ? "5px" : 0)};
    font-family: ${(props) => props.theme.openSans};
    font-size: ${(props) => props.theme.fontSizes.md}px;
    color: grey;
`

export const Default = (props: DefaultProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <DefaultSpan {...props}>
            {lang.default}
        </DefaultSpan>
    )
}
